const tableFieldsDef = {
  columns: [
    {
      type: 'index',
      width: 60,
      align: 'center'
    },
    {
      title: 'Filename',
      slot: 'fileViewCell',
      key: 'name',
      tree: true
    },
    {
      title: 'Description',
      key: 'description',
      tooltip: true
    },
    {
      title: 'Size',
      key: 'size'
    },
    {
      title: 'Date',
      key: 'created_at',
      tooltip: true
    },
    {
      title: 'Action',
      key: 'action',
      slot: 'actionCell'
    }
  ]
}

export default tableFieldsDef
